import PropTypes from 'prop-types';
import Dropdown from './NavbarFavoritesDropdown';
import NavbarFavoritePopUpActor from './NavbarFavoritesPopUpActors';
import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import { onClick } from './NavbarHelper';
import { Component } from 'react';

class NavbarFavorites extends Component {
	constructor(props) {
		super(props);
		this.state = {
			onlineCount: Flux.Favorite.getOnlineCount(),
			favoriteActors: Flux.Favorite.getActors(),
		};

		this.maxVisibleItems = 5;

		this.onFavoriteActorsChange = this.onFavoriteActorsChange.bind(this);
	}

	componentDidMount() {
		Flux.Favorite.addActorsChangeListener(this.onFavoriteActorsChange);
	}

	componentWillUnmount() {
		Flux.Favorite.removeActorsChangeListener(this.onFavoriteActorsChange);
	}

	onFavoriteActorsChange() {
		this.setState({
			onlineCount: Flux.Favorite.getOnlineCount(),
			favoriteActors: Flux.Favorite.getActors(),
		});
	}

	render() {
		// create unread item count label
		let badge = false;
		if (this.state.onlineCount > 0) {
			badge = <span className="badge--number">{this.state.onlineCount}</span>;
		}
		// Dropdown menu (don't render menu on server!)
		const dropdown = (
			<div>
				<NavbarFavoritePopUpActor favoriteActors={this.state.favoriteActors} isAfterLogin={this.props.isAfterLogin} />
				<Dropdown
					favoriteActors={this.state.favoriteActors}
					collectionUrl={this.props.collectionUrl}
					maxVisibleItems={this.maxVisibleItems}
				/>
			</div>
		);

		return (
			<div className="navigation__link">
				<a
					href="#"
					id="favoriteCount"
					data-toggle="dropdown"
					className="js-dropdown-toggle navigation__link"
					role="button"
					aria-haspopup="true"
					aria-expanded="false"
					data-tooltip-content={Translations.get('NavbarFavoritesTooltip')}
					data-tooltip-id="tooltip-bottom"
					onClick={onClick}
				>
					<i className="navigation__icon -icon-heart-full" />
					<span className="navigation__label">{Translations.get('NavbarFavoritesLabel')}</span>
					{badge}
				</a>
				{dropdown}
			</div>
		);
	}
}

NavbarFavorites.propTypes = {
	collectionUrl: PropTypes.string,
	isAfterLogin: PropTypes.bool,
};

export default NavbarFavorites;
